/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type IncomeSummaryProps = {
  formData: Record<string, any>;
};

const IncomeSummary = ({ formData }: IncomeSummaryProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Einnahmen</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasSocialWelfare"} sx={summaryStyle.scrollToAnchor} />
        Sozialhilfe
      </Grid>
      <Grid size={12}>
        {formData.hasSocialWelfare === "yes" ? "Es wird Sozialhilfe bezogen" : "Es wird keine Sozialhilfe bezogen"}
      </Grid>
      <>
        <Grid sx={summaryStyle.question} size={12}>
          Einkommensarten
        </Grid>

        <Box id={"hasIncomeEmployment"} sx={summaryStyle.scrollToAnchor} />
        <Grid size={12}>
          {formData.hasIncomeEmployment === "yes" ? "Arbeitnehmerlohn: " + formData.incomeEmploymentAmount + " €" : "Kein Arbeitnehmerlohn"}
        </Grid>

        <Box id={"hasIncomeSelfEmployment"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeSelfEmployment === "yes"
            ? "Selbstständigkeit: " + formData.incomeSelfEmploymentAmount + " €"
            : "Kein Einkommen als Selbstständiger"}
        </Grid>

        <Box id={"hasIncomeRent"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeRent === "yes" ? "Mieteinnahmen: " + formData.incomeRentAmount + " €" : "Keine Mieteinnahmen"}
        </Grid>

        <Box id={"hasIncomeAssets"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeAssets === "yes" ? "Kapitalvermögenserträge: " + formData.incomeAssetsAmount + " €" : "Keine Kapitalvermögenserträge"}
        </Grid>

        <Box id={"hasIncomeChildAllowance"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeChildAllowance === "yes" ? "Kindergeld/-zuschlag: " + formData.incomeChildAllowanceAmount + " €" : "Kindergeld/-zuschlag"}
        </Grid>

        <Box id={"hasIncomeLiving"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeLiving === "yes" ? "Wohngeld: " + formData.incomeLivingAmount + " €" : "Kein Wohngeld"}
        </Grid>

        <Box id={"hasIncomeAlimony"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeAlimony === "yes" ? "Unterhalt: " + formData.incomeAlimonyAmount + " €" : "Keinen Unterhalt"}
        </Grid>

        <Box id={"hasIncomePension"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomePension === "yes" ? "Rente/Pension: " + formData.incomePensionAmount + " €" : "Keine Rente/Pension"}
        </Grid>

        <Box id={"hasIncomeUnemploymentAllowance"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeUnemploymentAllowance === "yes"
            ? "Arbeitslosengeld I: " + formData.incomeUnemploymentAllowanceAmount + " €"
            : "Kein Arbeitslosengeld I"}
        </Grid>

        <Box id={"hasIncomeUnemploymentAllowance2"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeUnemploymentAllowance2 === "yes"
            ? "Arbeitslosengeld II: " + formData.incomeUnemploymentAllowance2Amount + " €"
            : "Kein Arbeitslosengeld II"}
        </Grid>

        <Box id={"hasIncomeSickness"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeSickness === "yes" ? "Krankengeld: " + formData.incomeSicknessAmount + " €" : "Kein Krankengeld"}
        </Grid>

        <Box id={"hasIncomeParentalAllowance"} sx={summaryStyle.scrollToAnchor} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeParentalAllowance === "yes" ? "Elterngeld: " + formData.incomeParentalAllowanceAmount + " €" : "Kein Elterngeld"}
        </Grid>

        <Grid sx={summaryStyle.question} size={12}>
          <Box id={"hasIncomeOther1"} sx={summaryStyle.scrollToAnchor} />
          Sonstiges Einkommen
        </Grid>
        <Grid size={12}>
          {formData.hasIncomeOther1 === "yes" ? (
            <>
              <br />
              Beschreibung: {formData.incomeOther1Name} mit einem Bruttobetrag von {formData.incomeOther1Amount} € ({formData.incomeOther1Period})
            </>
          ) : (
            "Kein sonstiges Einkommen"
          )}
          {formData.hasIncomeOther2 === "yes" && (
            <>
              <br />
              <br />
              Beschreibung: {formData.incomeOther2Name} mit einem Bruttobetrag von {formData.incomeOther2Amount} € ({formData.incomeOther2Period})
            </>
          )}
        </Grid>

        {formData.incomeDescription && (
          <>
            <Box id={"incomeDescription"} sx={summaryStyle.scrollToAnchor} />
            <Grid size={12}>
              Beschreibung: {formData.incomeDescription}
            </Grid>
          </>
        )}
      </>
    </>
  );
};

export default IncomeSummary;
